(ns rothko.theme.manatee.tooltip
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem px]]))

(def tip
  {:plain-black
   {:display :initial
    :background-color :black
    :color :white
    :padding (rem 1)
    :border-radius (rem 1)}

   :small-grey
   {:display :initial
    :background-color :grey
    :color :white
    :padding "0 0.5rem 0 0.5rem"
    :border-radius (rem 1)}

   :centered-triangle
   {:segments #{:top}
    :left "50%"
    :bottom (px -10)
    :pos "(-50%,0)"
    :size (px 5)}

   :leftward-triangle
   {:segments #{:right}
    :left (px -10)
    :top "50%"
    :pos "(0,50%)"
    :size (px 5)}

   :sw-triangle
   {:segments #{:left :bottom}
    :pos "(0,-50%)"
    :bottom (px -5)
    :left (px -5)
    :size (px 5)}})
